<!-- <app-edite-user-details></app-edite-user-details> -->


<!-- start content page  -->
<!-- start header  -->
<header>
  <app-head (newItemEvent)="addItem($event)" [titleModule]="'Push Messages'"></app-head>
</header>
<!-- end header  -->

<div class="row m-0">

  <!-- start sidebar  -->
  <app-sidebar class="col-lg-2" [showSide]="showSide" [titlepage]="'Push Messages'"></app-sidebar>
  <!-- end sidebar  -->

  <!-- start content page  -->
  <main class="p-4 col-lg-10 ">
      <!-- <div class="row">
          <p-breadcrumb class="max-w-full" [model]="[{label:'FAQ'}]" [home]="home"></p-breadcrumb>

      </div> -->
      <div class="fw-inquiries d-flex justify-content-between" style="color: #6c6a6a;">
          <p style=" font-family: Poppins;font-size: 16px;font-weight:600;color:#6c6a6a">Push Messages</p>
          <div class="d-flex justify-content-lg-between  ">

              <!-- start dropdown button  -->
              <!-- <app-dropdown class="me-3" [list]="listDropDown" (selected)="selectedfromDropDown($event)"></app-dropdown> -->
              <!-- end dropdown button  -->
              <!-- start add button (Push Message owner) in page  -->
              <!-- <app-add-new-button [id]="'/owner/create_new'" class="mt-2"></app-add-new-button> -->

              <!-- end add button (Push Message owner) in page  -->
          </div>
          <!-- start add button (Push Message apartment) in page  -->
          <!-- end add button (Push Message apartment) in page  -->

      </div>
      <p-toast></p-toast>
      <div class="card mt-2">
          <div class="d-flex justify-content-between">
              <!-- length Of person -->
              <div class="d-flex mx-2 mt-4">
                  <p class="me-2 fs-5 fw-bold ml-8">Push Message : {{numberMsgs}}</p>

              </div>
              <!-- search input -->
              <div class="d-flex align-items-center mx-2 mt-2">
                  <a class="px-3 py-2 rounded border text-white text-decoration-none  marmodify" (click)="openmodelcreateMsgs()" style="background-color:#1F4068; cursor: pointer; ">
                      <img src="assets/images/plus.svg" class="me-2 ">Push Message
                  </a>
              </div>
          </div>
          <!-- <p-table #dt1 [value]="FAQ" [(selection)]="selectppdd" dataKey="id1" [filterDelay]="0" /> -->



          <p-table class="table-shopping" [selectionPageOnly]="true" [tableStyle]="{'min-width': '50rem' ,'min-': '50rem'}" [value]="Msgs">
              <ng-template pTemplate="header" class="text-center">
                  <tr *ngIf="headerData">
                      <ng-container>

                          <th class="td-name">
                              Message User

                          </th>
                          <th class="td-name">
                              Message Title


                          </th>
                          <th class="td-name">
                            Message Body


                        </th>
                        <th class="td-name">
                          Message Date


                      </th>


                      </ng-container>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-fqq>

                  <tr style="cursor: pointer;" (click)="hidecard()">


                      <td>
                          {{fqq?.user_Name}}
                      </td>
                      <td>
                          {{fqq?.msg_Title}}
                      </td>
                      <td>
                        {{fqq?.msg_Body}}
                    </td>
                    <td>
                      {{fqq?.msg_Date}}
                  </td>


                  </tr>

              </ng-template>


              <ng-template pTemplate="emptymessage">
                  <div class="container text-center mt-4">
                      <p class="mb-0">No data found.</p>
                  </div>
              </ng-template>

          </p-table>
          <p-paginator *ngIf="Msgs.length > 0" (onPageChange)="tiggerPageChange($event)" [rows]="rows"
            [totalRecords]="totalRecords" [first]="first"></p-paginator>

          <!-- <div style="width: 100%; height: 72px; padding-top: 12px; padding-bottom: 16px; padding-left: 24px; padding-right: 24px;   justify-content: space-between; align-items: center; display: inline-flex">
      <div style="border-radius: 4px; justify-content: flex-start; align-items: flex-start; gap: 10px; display: flex">

          <button (click)="decreamentPage( )" [disabled]="disableperv" class="  cvxs" style="text-align: center; color: #1F4068; font-size: 16px; font-family: 'Montserrat'; font-weight: 500; line-height: 20px; word-wrap: break-word">
        Previous
  </button>
      </div>
      <div style="color: #484649; font-size: 14px; font-family: 'Montserrat'; font-weight: 400; line-height: 20px; word-wrap: break-word">Page {{pageNumber}} of {{totalofPages}}</div>
      <div style="border-radius: 4px; justify-content: flex-start; align-items: flex-start; gap: 10px; display: flex">

          <button [disabled]="disablenext" (click)="   incrementpage( )" class="  cvxs" style="text-align: center; color: #1F4068; font-size: 16px; font-family: 'Montserrat'; font-weight: 500; line-height: 20px; word-wrap: break-word">
            Next
  </button>
      </div>
  </div> -->
      </div>
  </main>
  <!-- end content page  -->
</div>


<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display1}" style=" background-color: rgb(23 22 22 / 50%);;">
  <div class="modal-dialog" role="document">
      <div class="modal-content" style="    margin-top: 150px;">
          <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
              <p class="modal-title" style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                  <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
              Push Message
      </span>
              </p>
              <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close" aria-label="Close" (click)="onCloseModal1()">
<span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
</button>



          </div>

          <div class="modal-body">


              <div class="row">
                <div class="mb-3 col-12 col-md-12">
                  <label class="form-label gray fw-bold">User</label>
                  <!-- start dropdown button  -->
                  <div class="selectForm">
                      <!-- <app-dropdown [list]="listDropDownArea" [holder]="selectArea" (selected)="selectedfromDropDownArea($event,'insert')"></app-dropdown> -->
                      <select class="form-select mb-3" [(ngModel)]="UserID"   #UserSelect (change)='onUserSelected(UserSelect.value)'>
                        <option value="0" disabled  selected>Select User</option>

                       <option *ngFor="let type of listDropDownArea" value="{{type.user_ID}}"> {{type.user_Name}} </option>
                  </select>

                  </div>
                  <!-- end dropdown button  -->
              </div>

                  <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Message Title</label>
                      <input type="text" [(ngModel)]="Question_title" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                  </div>
                  <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputSecuritydeposit" class="form-label gray fw-bold">Message Body</label>
                      <textarea class="border p-3 pt-3 rounded-2 w-100" [(ngModel)]="question_answer" rows="5" style="resize: inherit"></textarea>

                  </div>
              </div>

          </div>




          <div class="modal-footer">

                  <div class="d-flex justify-content-between w-100">
                      <a (click)="onCloseModal1()" style="    border: 1px solid;" class="backcancel text-decoration-none cursor bg-white rounded-2 py-2 px-3 fw-bold  xcvddmodel">
                Cancel
  </a>
                      <button (click)="CreateFAQ()" class="rounded-2 text-white rounded-2 border-0 py-2 px-4" style="background-color: #1f4068 !important">
                confirm
  </button>
                  </div>
              <!-- Confirm -->

          </div>


      </div>
      <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>

<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display2}" style=" background-color: rgb(23 22 22 / 50%);;">
  <div class="modal-dialog" role="document">
      <div class="modal-content" style="    margin-top: 150px;">
          <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
              <p class="modal-title" style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                  <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
              Update FAQ
      </span>
              </p>
              <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close" aria-label="Close" (click)="onCloseModal2()">
<span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
</button>



          </div>

          <div class="modal-body">


              <div class="row">
                  <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputPricepermonth" class="form-label gray fw-bold">Question title</label>
                      <input type="text" [(ngModel)]="Question_title_update" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                  </div>
                  <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputSecuritydeposit" class="form-label gray fw-bold">question answer</label>
                      <textarea class="border p-3 pt-3 rounded-2 w-100" [(ngModel)]="question_answer_update" rows="5" style="resize: inherit"></textarea>

                  </div>
              </div>

          </div>







      </div>
      <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display3}" style=" background-color: rgb(23 22 22 / 50%);;">
  <div class="modal-dialog" role="document">
      <div class="modal-content" style="    margin-top: 150px;">
          <div class="modal-header" style="background-color:#ffffff; border-bottom: none !important;position: relative;">
              <p class="modal-title" style="color: #1C1B1F; font-size: 20px;   font-weight: 600; line-height: 24px; word-wrap: break-word">
                  <span class="form-label gray fw-bold" style="vertical-align: middle; padding-left:8px">
              Push Message advertisement
    </span>
              </p>
              <button type="button" style="border:none;background-color: #ffffff;width: 68px;height: 50px;" class="close" aria-label="Close" (click)="onCloseModal3()">
<span aria-hidden="true" style="color: #000000;font-size: 35px;">&times;</span>
</button>



          </div>

          <div class="modal-body">


              <div class="row">

                  <label class="form-label gray fw-bold"> Upload picture
          </label>
                  <div class="position-relative h-124px mb-3">

                      <input type="file" accept="image/*" (change)="selectFile($event)" class="ng-star-inserted d-block w-100 h-124px file position-absolute">
                      <img src="assets/images/apartmentImages/_File upload base.svg" class="position-absolute" width="907%">

                  </div>

              </div>
              <div class="row" *ngIf="urls != null">
                  <div class="col-md-2 card33">
                      <a (click)="removeItem()" style="border: none;   margin-bottom: 10px; position: absolute;">
                          <img class="imageRemove" src="../../../../../../assets/images/delete.svg" width="32px" height="32px;">
                      </a>
                      <img [src]="urls" alt="Avatar" style="width:350px;height:205px ; ">

                  </div>
              </div>
              <div class="row">
                  <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputPricepermonth" class="form-label gray fw-bold">link</label>
                      <input type="text" [(ngModel)]="link_create_ads" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                  </div>
              </div>
              <div class="row">
                  <div class="mb-3 col-12 col-md-12">
                      <label for="exampleInputPricepermonth" class="form-label gray fw-bold">button name</label>
                      <input type="text" [(ngModel)]="button_name" class="form-control rounded-2 py-2 fs-6" id="exampleInputPricepermonth" />

                  </div>
              </div>
          </div>






      </div>
      <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
